module.exports = __webpack_public_path__ + "static/media/ajax-loader.3aae1381.gif";